import FilterChange from "@app/shared/filters/filter-change.model";

export default class FilterSetChange {
  public filters: FilterChange[];

  constructor(filters: FilterChange[] = []) {
    this.filters = filters;
  }
}
